import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../../Popover/TextTooltipOnHover';
import { MobileContext } from '../../../Context/MobileContext';
var ToolbarIconTooltip = function (_a) {
    var className = _a.className, tooltipText = _a.tooltipText, tooltipTextKey = _a.tooltipTextKey, children = _a.children;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return isMobile ? (React.createElement("div", { className: className }, children)) : (React.createElement(TextTooltipOnHover, { className: className, tooltipText: tooltipTextKey ? t(tooltipTextKey) : tooltipText, tooltipOffset: '0, 4' }, children));
};
ToolbarIconTooltip.displayName = 'ToolbarIconTooltip';
export default ToolbarIconTooltip;
//# sourceMappingURL=ToolbarIconTooltip.js.map